import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { permissionObj } from "../../../../../../../Helpers/permission";
import { errorMsg } from "../../../../../../../Apis/functions";
import { TABLES } from "../../../../../../../Apis/Tables";
import { DeleteItemsApi } from "../../../../../../../reduxToolkit/Commons/CommonsApi";
import { SimpleSearchWithId } from "../../../../../../../reduxToolkit/Search/SearchApi";
import { SEARCH_MODEL } from "../../../../../../../components/table/Model/TableModel";
import DeductionPolicyCard from "../SubComponents/DeductionPolicyCard";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const AssignedGlobalDeductionsApp = ({
    id,
    selectForDelete,
    setSelectForDelete,
    setModified,
    triggerDelete,
    setTriggerDelete,
    setIsAllChecked,
    readOnly
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const deletePermission = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_DEDUCTION_POLICY_USER_DELETE);

    const isCreate = id === null || id === undefined;
    const [deleteModalShow, setDeleteModalShow] = useState(false);

    const renderAssignedItem = ({ item, keyId, onDelete, checkbox, handleCheckboxChange, selected: sel }) => (
        <DeductionPolicyCard
            item={{ ...item, checked: sel?.includes(item[keyId]) }}
            keyId={keyId}
            onDelete={readOnly ? undefined : onDelete}
            handleCheckboxChange={readOnly ? undefined : (checkbox ? handleCheckboxChange : undefined)}
        />
    );

    const dynamicConfig = useMemo(() => ({
        keyId: 'id',
        model: TABLES.PAYROLL_DEDUCTION_POLICY_EXCLUSION,
        labelRowsPerPage: 'deductions_per_page',
        tableNotInformationLegend: 'you_have_not_excluded_any_deduction_policies_yet',
        searchLabel: 'search',
        title_modal: 'remove_deductions',
        element_modal: 'deductions',
        renderAssignedItem,
    }), [readOnly]);

    const buildBody = ({ page, rowsPerPage, searchElement: key }) => ({
        body: SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            key,
            model: dynamicConfig.model,
            userId: id,
        }),
    });

    useEffect(() => {
        if (triggerDelete === true) {
            handleDelete();
            setTriggerDelete(false);
        }
    }, [triggerDelete]);

    const handleDelete = (item) => {
        if (item) setSelectForDelete([item[dynamicConfig.keyId]]);
        setDeleteModalShow(true);
    };

    const hide = () => {
        setSelectForDelete([]);
        setIsAllChecked(false);
        setDeleteModalShow(false);
    };

    const onDelete = () => {
        if (selectForDelete.length <= 0) return;

        dispatch(DeleteItemsApi({ tableName: dynamicConfig.model, body: selectForDelete }))
            .then(({ payload: { data: { success, code } } }) => {
                if (!success) {
                    errorMsg(code);
                    return;
                }
                setModified(true);
                hide();
            });
    };

    return {
        t,
        isCreate,
        deletePermission,
        deleteModalShow,
        dynamicConfig,
        assignedEndPoint: SimpleSearchWithId,
        buildBody,
        handleDelete,
        onDelete,
        hide,
    };
};
